import { Box, Skeleton } from '@mui/material';
import React from 'react';

const CourseListSkeletonLoader = () => {
  return (
    <div className="skeleton-wrapper">
      <Box flex={1}>
        <Skeleton
          variant="rectangular"
          width="100%"
          height={120}
          style={{ borderRadius: '5px', marginTop: '20px', marginBottom: '20px' }}
        />
      </Box>
      {Array(6)
        .fill(0)
        .map((_, i) => (
          <div className="course-item-wrapper" key={i}>
            <div className="course-item flex-container margin-top--md">
              <Box flex={1} marginTop={2} marginRight={1}>
                <Skeleton
                  variant="rectangular"
                  width="100%"
                  height={120}
                  style={{ borderRadius: '5px' }}
                />
              </Box>

              <Box marginRight={1} flex={1} marginTop={2}>
                <Skeleton width="100%" height={30} />
                <Skeleton width="100%" height={30} />
                <Skeleton width="100%" height={30} />
                <Skeleton width="100%" height={30} />
              </Box>
            </div>
          </div>
        ))}
      <style jsx>
        {`
          .skeleton-wrapper {
            max-width: 1150px;
            margin: auto;
            padding: 20px;
          }
          .course-item-wrapper {
            margin: auto;
            max-width: 900px;
            width: 70%;
          }
          @media only screen and (max-width: 1050px) {
            .course-item-wrapper {
              width: 80%;
            }
          }
          @media only screen and (max-width: 950px) {
            .course-item-wrapper {
              width: 100%;
            }
          }
          @media only screen and (max-width: 600px) {
            .course-item {
              flex-direction: column;
            }
          }
        `}
      </style>
    </div>
  );
};

export default CourseListSkeletonLoader;
